import { IState } from '@/interfaces/store.interfaces';

export const initialState: IState = {
	areDependenciesLoaded: false,
	shouldShowChatUI: false,
	chatSessionId: null,
	chatHistory: [],
	userSessions: null,
	userNationalityCountryIso: 'NL',
	userCurrency: 'EUR',
	canLoadUserSession: false,
	isSidebarOpen: true,
	shouldShowFooter: true,
	bestfitCompletness: false,
	userId: null,
	activeStudyId: null,
}